import { render, staticRenderFns } from "./Cold.vue?vue&type=template&id=35cf3d20&"
import script from "./Cold.vue?vue&type=script&lang=js&"
export * from "./Cold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports